import { RemoteGetActivitiesInProgressCount } from 'data/usecases';
import { GetActivitiesInProgressCount } from 'domain/usecases';
import { makeApiUrlActivitiesInProgressCount } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetActivitiesInProgressCount =
  (): GetActivitiesInProgressCount =>
    new RemoteGetActivitiesInProgressCount(
      makeApiUrlActivitiesInProgressCount(),
      makeAxiosHttpClient(),
    );
